import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { PartnersBanner } from "@/components/home/PartnersBanner";
import { PackagesPreview } from "@/components/home/PackagesPreview";
import { ServicesLinks } from "@/components/home/ServicesLinks";

import { Testimonials, reviewSchema } from "@/components/home/Testimonials";
import { ConsultationForm } from "@/components/home/ConsultationForm";
import { FinalCTA } from "@/components/home/FinalCTA";
import { SEO } from "@/components/SEO";
import { organizationSchema, localBusinessSchema, siteNavigationSchema } from "@/lib/structuredData";

const Index = () => {
  return (
    <Layout>
      <SEO 
        title="Bookkeeping Services South Africa | SAICA Registered"
        description="SAICA-registered bookkeeping and accounting in South Africa from R2,500/month. We work with Xero, Sage, Pastel and other accounting systems. Payroll, VAT and SARS compliance included."
        canonical="/"
        structuredData={[organizationSchema, localBusinessSchema, siteNavigationSchema, reviewSchema]}
      />
      <HeroSection />
      <PartnersBanner />
      <PackagesPreview />
      <ServicesLinks />
      
      
      <Testimonials />
      <ConsultationForm />
      <FinalCTA />
    </Layout>
  );
};

export default Index;
